import keyMirror from 'keymirror';

export default keyMirror({
  CHANGES_PERSISTED: null,
  CURRENT_ACTIVE_STEP_UPDATED: null,
  SYNC_ACTIVE_STEP: null,
  UPDATED: null,
}, 'ACTIVE_STEP');
